import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AccountAuth from "@/pages/AccountAuth";
import MyLibrary from "@/pages/MyLibrary";
import BookPage from "@/pages/BookPage";
import { CustomerAuthProvider } from "@/context/CustomerAuthContext";

function AppRoutes() {
  const location = useLocation();
  // Handle the Emergent OAuth callback BEFORE any protected route runs
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<SmoothScroll><Home /></SmoothScroll>} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/account" element={<AccountAuth />} />
      <Route path="/library" element={<MyLibrary />} />
      <Route path="/books/the-grace-between-us" element={<BookPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <div className="grain" />
      <Toaster theme="light" position="top-center" toastOptions={{ style: { borderRadius: 0, fontFamily: "Manrope, sans-serif", fontSize: 13, background: "#FFFFFF", color: "#0E1E2E", border: "1px solid rgba(0,0,0,0.1)" } }} />
      <AuthProvider>
        <CustomerAuthProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </CustomerAuthProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
